export const SUPPORTS_ARRAY_PROTOTYPE_COPY_WITHIN = "copyWithin" in Array.prototype;
